import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border border-slate-200 bg-slate-50 p-3"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-start justify-between gap-3"
};
const _hoisted_3 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  class: "mt-3 grid grid-cols-1 gap-2 md:grid-cols-2"
};
const _hoisted_7 = {
  class: "rounded-md bg-white px-3 py-2"
};
const _hoisted_8 = {
  class: "mt-1 text-sm font-medium text-slate-900"
};
const _hoisted_9 = ["title"];
const _hoisted_10 = {
  key: 1,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_11 = {
  class: "rounded-md bg-white px-3 py-2"
};
const _hoisted_12 = {
  class: "mt-1 text-sm font-medium text-slate-900"
};
const _hoisted_13 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
import { computed } from 'vue';
import { downstreamAllocationSummary, downstreamPreferenceSummary } from '../downstreamRules.mjs';
import { formatInvoiceAmount } from '../utils';
export default {
  __name: 'InvoiceCustomerInvoiceRulePanel',
  props: {
    customer: {
      type: Object,
      default: null
    },
    downstreamAllocations: {
      type: Array,
      default: () => []
    },
    downstreamTagPreferences: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['configure-downstream', 'configure-tag-preference'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const customerId = computed(() => props.customer?.id || props.customer?.planCustomerId || null);
    const customer = computed(() => props.customer ? {
      ...props.customer,
      id: customerId.value
    } : null);
    const allocationSummary = computed(() => downstreamAllocationSummary(props.downstreamAllocations, customer.value));
    const preferenceSummary = computed(() => downstreamPreferenceSummary(props.downstreamTagPreferences, customerId.value));
    const allocationText = computed(() => {
      if (!customerId.value) return '客户加入本月后可设置';
      if (allocationSummary.value.enabledCount === 0) return '未指定下游';
      return `已指定 ${allocationSummary.value.enabledCount} 个下游，合计 ${formatInvoiceAmount(allocationSummary.value.totalAmount)}`;
    });
    const preferenceText = computed(() => {
      if (!customerId.value) return '客户加入本月后可设置';
      if (preferenceSummary.value.enabledCount === 0) return '未设置标签偏好';
      return preferenceSummary.value.shortText;
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("div", null, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-900"
      }, "链路匹配规则"), _createElementVNode("p", {
        class: "mt-1 text-xs text-slate-500"
      }, "维护该客户当月开票链路的指定下游和标签偏好。")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary px-3 py-1.5 text-xs",
        disabled: __props.disabled || !customerId.value,
        onClick: _cache[0] || (_cache[0] = $event => emit('configure-downstream', customer.value))
      }, [...(_cache[2] || (_cache[2] = [_createTextVNode(" 设置指定下游 ", -1)]))], 8, _hoisted_4)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary px-3 py-1.5 text-xs",
        disabled: __props.disabled || !customerId.value,
        onClick: _cache[1] || (_cache[1] = $event => emit('configure-tag-preference', customer.value))
      }, [...(_cache[3] || (_cache[3] = [_createTextVNode(" 设置标签偏好 ", -1)]))], 8, _hoisted_5)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "text-xs text-slate-500"
      }, "指定下游", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(allocationText.value), 1), allocationSummary.value.targetNamesText ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mt-1 truncate text-xs text-slate-600",
        title: allocationSummary.value.targetNamesText
      }, " 下游：" + _toDisplayString(allocationSummary.value.targetNamesText), 9, _hoisted_9)) : _createCommentVNode("", true), allocationSummary.value.enabledCount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 剩余自动生成 " + _toDisplayString(_unref(formatInvoiceAmount)(allocationSummary.value.remainingAmount)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "text-xs text-slate-500"
      }, "标签偏好", -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(preferenceText.value), 1), preferenceSummary.value.hiddenCount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 另有 " + _toDisplayString(preferenceSummary.value.hiddenCount) + " 个偏好标签 ", 1)) : _createCommentVNode("", true)])])]);
    };
  }
};